export type TicketModel = {
  id: number;
  voidedAt?: object;
  bgColorHex: string;
  fontColorHex: string;
  description: string;
  longDescription: string;
  isGA: boolean;
  additionalInfos: TicketAdditionalInfo[];
  exitPortal: string;
  shouldNotShowBarcode: boolean;
  showGARef: boolean;
  section: string;
  row: string;
  seat: string;
  barcode: string;
  isSecureEntry: boolean;
  rotatingEntryToken: string;
  renderType: string;
  fee: number;
  fees: FeeModel[];
  price: number;
  tax: number;
  discount: number;
  currencyCode: string;
}

export type TicketAdditionalInfo = {
  key: string;
  type: string;
  value: string;
  index: number;
}

export type FeeModel = {
  name: string;
  value: number;
}

export function getBestDescription(ticket: TicketModel): string {
  return ticket.longDescription || ticket.description;
}

export function isTicket(item: any): item is TicketModel {
  return 'section' in item && 'row' in item && 'seat' in item;
}
